import { http } from '@/http/index'

export const getSubscriptions = async () => http.get('/consumer/subscriptions').then((response) => response.data)

export const getMoreSubscriptions = async (url) => http.get(url).then((response) => response.data)
